export default "__VITE_ASSET__BFLsC4dI__"